export default __webpack_public_path__ + "static/media/voice-toggle-2.43542014.webp";